/**
 * Complete Table of Contents for the Bible.
 */
export const TOC = {
    OT: [
        { name: 'Genesis', abbrev: 'Gen', fileName: 'Genesis', chapterCount: 50 },
        { name: 'Exodus', abbrev: 'Exo', fileName: 'Exodus', chapterCount: 40 },
        { name: 'Leviticus', abbrev: 'Lev', fileName: 'Leviticus', chapterCount: 27 },
        { name: 'Numbers', abbrev: 'Num', fileName: 'Numbers', chapterCount: 36 },
        { name: 'Deuteronomy', abbrev: 'Deu', fileName: 'Deuteronomy', chapterCount: 34 },
        { name: 'Joshua', abbrev: 'Jos', fileName: 'Joshua', chapterCount: 24 },
        { name: 'Judges', abbrev: 'Jdg', fileName: 'Judges', chapterCount: 21 },
        { name: 'Ruth', abbrev: 'Rth', fileName: 'Ruth', chapterCount: 4 },
        { name: '1 Samuel', abbrev: '1 Sam', fileName: '1Samuel', chapterCount: 31 },
        { name: '2 Samuel', abbrev: '2 Sam', fileName: '2Samuel', chapterCount: 24 },
        { name: '1 Kings', abbrev: '1 Kgs', fileName: '1Kings', chapterCount: 22 },
        { name: '2 Kings', abbrev: '2 Kgs', fileName: '2Kings', chapterCount: 25 },
        { name: '1 Chronicles', abbrev: '1 Chr', fileName: '1Chronicles', chapterCount: 29 },
        { name: '2 Chronicles', abbrev: '2 Chr', fileName: '2Chronicles', chapterCount: 36 },
        { name: 'Ezra', abbrev: 'Ezr', fileName: 'Ezra', chapterCount: 10 },
        { name: 'Nehemiah', abbrev: 'Neh', fileName: 'Nehemiah', chapterCount: 13 },
        { name: 'Esther', abbrev: 'Est', fileName: 'Esther', chapterCount: 10 },
        { name: 'Job', abbrev: 'Job', fileName: 'Job', chapterCount: 42 },
        { name: 'Psalms', abbrev: 'Psa', fileName: 'Psalms', chapterCount: 150 },
        { name: 'Proverbs', abbrev: 'Pro', fileName: 'Proverbs', chapterCount: 31 },
        { name: 'Ecclesiastes', abbrev: 'Ecc', fileName: 'Ecclesiastes', chapterCount: 12 },
        { name: 'Song of Solomon', abbrev: 'Sng', fileName: 'SongofSolomon', chapterCount: 8 },
        { name: 'Isaiah', abbrev: 'Isa', fileName: 'Isaiah', chapterCount: 66 },
        { name: 'Jeremiah', abbrev: 'Jer', fileName: 'Jeremiah', chapterCount: 52 },
        { name: 'Lamentations', abbrev: 'Lam', fileName: 'Lamentations', chapterCount: 5 },
        { name: 'Ezekiel', abbrev: 'Eze', fileName: 'Ezekiel', chapterCount: 48 },
        { name: 'Daniel', abbrev: 'Dan', fileName: 'Daniel', chapterCount: 12 },
        { name: 'Hosea', abbrev: 'Hos', fileName: 'Hosea', chapterCount: 14 },
        { name: 'Joel', abbrev: 'Joe', fileName: 'Joel', chapterCount: 3 },
        { name: 'Amos', abbrev: 'Amo', fileName: 'Amos', chapterCount: 9 },
        { name: 'Obadiah', abbrev: 'Oba', fileName: 'Obadiah', chapterCount: 1 },
        { name: 'Jonah', abbrev: 'Jon', fileName: 'Jonah', chapterCount: 4 },
        { name: 'Micah', abbrev: 'Mic', fileName: 'Micah', chapterCount: 7 },
        { name: 'Nahum', abbrev: 'Nah', fileName: 'Nahum', chapterCount: 3 },
        { name: 'Habakkuk', abbrev: 'Hab', fileName: 'Habakkuk', chapterCount: 3 },
        { name: 'Zephaniah', abbrev: 'Zep', fileName: 'Zephaniah', chapterCount: 3 },
        { name: 'Haggai', abbrev: 'Hag', fileName: 'Haggai', chapterCount: 2 },
        { name: 'Zechariah', abbrev: 'Zec', fileName: 'Zechariah', chapterCount: 14 },
        { name: 'Malachi', abbrev: 'Mal', fileName: 'Malachi', chapterCount: 4 },
    ],
    NT: [
        { name: 'Matthew', abbrev: 'Mat', fileName: 'Matthew', chapterCount: 28 },
        { name: 'Mark', abbrev: 'Mar', fileName: 'Mark', chapterCount: 16 },
        { name: 'Luke', abbrev: 'Luk', fileName: 'Luke', chapterCount: 24 },
        { name: 'John', abbrev: 'Jhn', fileName: 'John', chapterCount: 21 },
        { name: 'Acts', abbrev: 'Act', fileName: 'Acts', chapterCount: 28 },
        { name: 'Romans', abbrev: 'Rom', fileName: 'Romans', chapterCount: 16 },
        { name: '1 Corinthians', abbrev: '1 Cor', fileName: '1Corinthians', chapterCount: 16 },
        { name: '2 Corinthians', abbrev: '2 Cor', fileName: '2Corinthians', chapterCount: 13 },
        { name: 'Galatians', abbrev: 'Gal', fileName: 'Galatians', chapterCount: 6 },
        { name: 'Ephesians', abbrev: 'Eph', fileName: 'Ephesians', chapterCount: 6 },
        { name: 'Philippians', abbrev: 'Php', fileName: 'Philippians', chapterCount: 4 },
        { name: 'Colossians', abbrev: 'Col', fileName: 'Colossians', chapterCount: 4 },
        { name: '1 Thessalonians', abbrev: '1 Th', fileName: '1Thessalonians', chapterCount: 5 },
        { name: '2 Thessalonians', abbrev: '2 Th', fileName: '2Thessalonians', chapterCount: 3 },
        { name: '1 Timothy', abbrev: '1 Tim', fileName: '1Timothy', chapterCount: 6 },
        { name: '2 Timothy', abbrev: '2 Tim', fileName: '2Timothy', chapterCount: 4 },
        { name: 'Titus', abbrev: 'Tit', fileName: 'Titus', chapterCount: 3 },
        { name: 'Philemon', abbrev: 'Phm', fileName: 'Philemon', chapterCount: 1 },
        { name: 'Hebrews', abbrev: 'Heb', fileName: 'Hebrews', chapterCount: 13 },
        { name: 'James', abbrev: 'Jam', fileName: 'James', chapterCount: 5 },
        { name: '1 Peter', abbrev: '1 Pet', fileName: '1Peter', chapterCount: 5 },
        { name: '2 Peter', abbrev: '2 Pet', fileName: '2Peter', chapterCount: 3 },
        { name: '1 John', abbrev: '1 Jhn', fileName: '1John', chapterCount: 5 },
        { name: '2 John', abbrev: '2 Jhn', fileName: '2John', chapterCount: 1 },
        { name: '3 John', abbrev: '3 Jhn', fileName: '3John', chapterCount: 1 },
        { name: 'Jude', abbrev: 'Jud', fileName: 'Jude', chapterCount: 1 },
        { name: 'Revelation', abbrev: 'Rev', fileName: 'Revelation', chapterCount: 22 },
    ],
    bookAbbrevMap: new Map(),
};
// Build the abbreviation map
TOC.OT.forEach((bs, bookIndex) => {
    const info = { ...bs, testamentIndex: 0, bookIndex };
    TOC.bookAbbrevMap.set(bs.abbrev.toLowerCase(), info);
    TOC.bookAbbrevMap.set(bs.name.toLowerCase(), info);
});
TOC.NT.forEach((bs, bookIndex) => {
    const info = { ...bs, testamentIndex: 1, bookIndex };
    TOC.bookAbbrevMap.set(bs.abbrev.toLowerCase(), info);
    TOC.bookAbbrevMap.set(bs.name.toLowerCase(), info);
});
// Common aliases people actually type
const ALIASES = {
    'ge': 'gen', 'gn': 'gen',
    'ex': 'exo',
    'le': 'lev', 'lv': 'lev',
    'nu': 'num', 'nm': 'num',
    'dt': 'deu', 'deut': 'deu',
    'josh': 'jos',
    'jdgs': 'jdg', 'judg': 'jdg',
    'ru': 'rth',
    '1 sa': '1 sam', '1sa': '1 sam',
    '2 sa': '2 sam', '2sa': '2 sam',
    '1 ki': '1 kgs', '1 kin': '1 kgs', '1ki': '1 kgs',
    '2 ki': '2 kgs', '2 kin': '2 kgs', '2ki': '2 kgs',
    '1 chron': '1 chr', '1 ch': '1 chr', '1ch': '1 chr',
    '2 chron': '2 chr', '2 ch': '2 chr', '2ch': '2 chr',
    'ezr': 'ezr',
    'ne': 'neh',
    'es': 'est',
    'jb': 'job',
    'ps': 'psa', 'psalm': 'psa',
    'pr': 'pro', 'prov': 'pro',
    'ec': 'ecc', 'eccl': 'ecc',
    'song': 'sng', 'sos': 'sng', 'ss': 'sng',
    'is': 'isa',
    'je': 'jer',
    'la': 'lam',
    'ezek': 'eze', 'ez': 'eze',
    'da': 'dan',
    'ho': 'hos',
    'jl': 'joe',
    'am': 'amo',
    'ob': 'oba', 'obad': 'oba',
    'jnh': 'jon',
    'mi': 'mic',
    'na': 'nah',
    'zph': 'zep', 'zeph': 'zep',
    'zch': 'zec', 'zech': 'zec',
    'ml': 'mal',
    'mt': 'mat', 'matt': 'mat',
    'mk': 'mar', 'mrk': 'mar',
    'lk': 'luk',
    'jn': 'jhn',
    'ac': 'act',
    'ro': 'rom',
    '1 co': '1 cor', '1co': '1 cor',
    '2 co': '2 cor', '2co': '2 cor',
    'ga': 'gal',
    'ep': 'eph',
    'phil': 'php', 'phi': 'php',
    'co': 'col',
    '1 thess': '1 th', '1 thes': '1 th', '1th': '1 th',
    '2 thess': '2 th', '2 thes': '2 th', '2th': '2 th',
    '1 ti': '1 tim', '1ti': '1 tim',
    '2 ti': '2 tim', '2ti': '2 tim',
    'ti': 'tit',
    'philem': 'phm', 'phlm': 'phm',
    'he': 'heb',
    'jas': 'jam', 'ja': 'jam',
    '1 pe': '1 pet', '1pe': '1 pet', '1 pt': '1 pet',
    '2 pe': '2 pet', '2pe': '2 pet', '2 pt': '2 pet',
    '1 jn': '1 jhn', '1 jo': '1 jhn', '1jn': '1 jhn',
    '2 jn': '2 jhn', '2 jo': '2 jhn', '2jn': '2 jhn',
    '3 jn': '3 jhn', '3 jo': '3 jhn', '3jn': '3 jhn',
    're': 'rev',
};
for (const [alias, canonical] of Object.entries(ALIASES)) {
    const info = TOC.bookAbbrevMap.get(canonical);
    if (info)
        TOC.bookAbbrevMap.set(alias, info);
}
/**
 * Total number of chapters in the Bible.
 */
export const TOTAL_CHAPTERS = TOC.OT.reduce((sum, b) => sum + b.chapterCount, 0) +
    TOC.NT.reduce((sum, b) => sum + b.chapterCount, 0); // 1189
/**
 * Total number of books.
 */
export const TOTAL_BOOKS = TOC.OT.length + TOC.NT.length; // 66
/**
 * Get book info by testament and book index.
 */
export function getBookInfo(testamentIndex, bookIndex) {
    const books = testamentIndex === 0 ? TOC.OT : TOC.NT;
    const book = books[bookIndex];
    if (!book)
        return null;
    return { ...book, testamentIndex, bookIndex };
}
/**
 * Get book info by abbreviation (case-insensitive).
 */
export function getBookByAbbrev(abbrev) {
    return TOC.bookAbbrevMap.get(abbrev.toLowerCase()) ?? null;
}
/**
 * Get all books as a flat array with indices.
 */
export function getAllBooks() {
    const books = [];
    TOC.OT.forEach((b, i) => books.push({ ...b, testamentIndex: 0, bookIndex: i }));
    TOC.NT.forEach((b, i) => books.push({ ...b, testamentIndex: 1, bookIndex: i }));
    return books;
}
//# sourceMappingURL=toc.js.map